export default __webpack_public_path__ + "static/media/ishopifyAdmin.0994df17.png";